import React from 'react'
import styled, { css } from 'styled-components'
import { media } from 'src/styles/styled-components'
import { generateJSX, handleClickAction } from 'src/utils'
import { RequestDemoModalContext } from 'src/context'

// ArComponents
import ArHeroHeading from 'src/components/typography/ArHeroHeading'
import ArHeroDescription from 'src/components/typography/ArHeroDescription'
import ArBaseButton from 'src/components/ArBaseButton/ArBaseButton'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${ ({ mobileContainerStyles }) => mobileContainerStyles }
  ${ media.tablet`${ ({ tabletContainerStyles }) => tabletContainerStyles }` }
  ${ media.desktop`${ ({ desktopContainerStyles }) => desktopContainerStyles }` }
`

const StyledButton = styled(ArBaseButton)`
  margin: 25px auto 0;

  ${ media.tablet`
    margin-top: 30px;
  ` }

  ${ media.desktop`
    ${ ({ scCenter }) =>
    !scCenter &&
      css`
        margin-left: 0;
      ` }
  ` }
`

function ArHeroHeadingWrapper ({
  title,
  description,
  cta,
  alignTextToCenter,
  alignTextToLeft,
  centerButton,
  buttonVariant,
  ...rest
}) {
  return (
    <RequestDemoModalContext.Consumer>
      {({ toggleModal }) => (
        <StyledContainer {...rest}>
          <ArHeroHeading
            scAlignTextToCenter={alignTextToCenter}
            scAlignTextToLeft={alignTextToLeft}
          >
            {title && typeof title !== 'string' ? generateJSX(title) : title}
          </ArHeroHeading>
          <ArHeroDescription
            scAlignTextToCenter={alignTextToCenter}
            scAlignTextToLeft={alignTextToLeft}
          >
            {description && typeof description !== 'string'
              ? generateJSX(description)
              : description}
          </ArHeroDescription>
          {cta && (
            <StyledButton
              scCenter={centerButton}
              onClick={
                cta.onClick
                  ? () => handleClickAction(cta.onClick)
                  : e => toggleModal(e)
              }
              label={cta.label}
              variant={buttonVariant || 'outline-black'}
            />
          )}
        </StyledContainer>
      )}
    </RequestDemoModalContext.Consumer>
  )
}

export default ArHeroHeadingWrapper
